import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IACOPY_FEEDBACK_CATEGORIES } from '../../models/ia-generation-outcome.model';

export interface IACopyEditDialogData {
  originalHeadline: string;
  originalBodyCopy: string;
  editableHeadline: string;
  editableBodyCopy: string;
  initialCategory?: string;
  initialNotes?: string;
}

export interface IACopyEditDialogResult {
  headline: string;
  bodyCopy: string;
  hasChanges: boolean;
  category?: string;
  notes: string;
}

@Component({
  selector: 'app-ia-copy-edit-dialog',
  templateUrl: './ia-copy-edit-dialog.component.html',
  styleUrls: ['./ia-copy-edit-dialog.component.scss'],
})
export class IACopyEditDialogComponent implements OnInit {
  readonly feedbackCategories = IACOPY_FEEDBACK_CATEGORIES;

  formGroup!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private matDialogRef: MatDialogRef<IACopyEditDialogComponent, IACopyEditDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: IACopyEditDialogData
  ) {}

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      editableHeadline: [this.data.editableHeadline ?? ''],
      editableBodyCopy: [this.data.editableBodyCopy ?? ''],
      category: [this.data.initialCategory ?? ''],
      feedbackNotes: [this.data.initialNotes ?? ''],
    });
  }

  closeDialog(): void {
    this.matDialogRef.close();
  }

  apply(): void {
    if (this.formGroup.invalid) {
      return;
    }

    const headline = this.formGroup.get('editableHeadline')?.value ?? '';
    const bodyCopy = this.formGroup.get('editableBodyCopy')?.value ?? '';
    const originalHeadline = this.data.originalHeadline ?? '';
    const originalBodyCopy = this.data.originalBodyCopy ?? '';
    const category = (this.formGroup.get('category')?.value ?? '').trim() || undefined;
    const notes = (this.formGroup.get('feedbackNotes')?.value ?? '').trim();

    const hasChanges =
      headline.trim() !== originalHeadline.trim() ||
      bodyCopy.trim() !== originalBodyCopy.trim();

    this.matDialogRef.close({ headline, bodyCopy, hasChanges, category, notes });
  }
}
